// Single source of truth for the KI-02 workshop (frontend).
// Every rendered fact (title, date, time, location) is consumed from here so the
// page cannot drift from the data. Prices are data-only and stay visually
// deactivated until AP-03. The identifier is intentionally date-independent.
export const WORKSHOP = {
  id: "koerperintelligenz",
  slug: "koerperintelligenz",
  title: "Körperintelligenz",
  titleFull: "Körperintelligenz – Gleichgewicht als Fundament",
  brand: "Die kleine Einheit",
  host: "Michael Kletschke",

  // Display strings (verbatim source for what the page shows)
  dateLong: "Samstag, 22. August 2026",
  dateShort: "Sa · 22. August 2026",
  dateNoWeekday: "22. August 2026",
  time: "10:00–14:00 Uhr",

  // Location: short form is what the page shows; structured form is for data/templates.
  locationShort: "Naturplatz Draußen Zuhause, Schledehausen",
  locationDistrict: "Schledehausen",
  location: {
    name: 'Naturplatz "Draußen Zuhause e.V."',
    street: "Alt-Schlederhausener Straße", // no house number exists — never invent one
    zip: "49143",
    city: "Bissendorf",
    country: "DE",
  },

  // Pricing (data only — deactivated visibly until AP-03)
  pricing: {
    early: { amount: 99, label: "Frühbucher" },
    regular: { amount: 149, label: "Regulär" },
    cutoff: "2026-08-12", // early bird valid through end of 12.08.2026 (Europe/Berlin)
    currency: "eur",
    vatPercent: 19,
  },
  earlyBirdUntil: "12.08.2026",
  cancelFreeUntil: "2026-08-12",
  cancelFreeUntilLong: "12. August 2026",
  cancelFreeUntilShort: "12.08.2026",
  capacityMax: 20,
  imageRights: "Michael Kletschke",

  contact: {
    email: "info@die-kleine-einheit.de",
    phone: "+49 179 2589296",
    whatsapp: "491792589296",
  },
  booking: {
    whatsappText: "Hallo Michael, ich möchte am 22.08. beim Workshop dabei sein.",
    emailSubject: "Anmeldung Körperintelligenz 22.08.",
  },
};
